import React from 'react';

const UserScreenerClientFormModal = React.lazy(() => import('../components/FormModal'));
const userScreenerClientModalRegistry = {
    personalize_userScreenerClientId: UserScreenerClientFormModal
};
export default userScreenerClientModalRegistry;
